import { SettingsClient } from "@amazon-connect/user";
import type { AmazonConnectProvider } from "@amazon-connect/core";
import type { ClientModule } from "../types";

/** SettingsClient also ships in @amazon-connect/user; language and visual mode. */
export const settingsModule: ClientModule = {
  id: "settings",
  label: "Settings",
  pkg: "@amazon-connect/user",
  clientExport: "SettingsClient",
  kind: "observable",
  create: (provider: AmazonConnectProvider) =>
    new SettingsClient({ provider }) as unknown as Record<string, unknown>,
  events: [
    { name: "onLanguageChanged", off: "offLanguageChanged" },
    { name: "onVisualModeChange", off: "offVisualModeChange" },
  ],
  requests: [
    { name: "getLanguage", args: [] },
    // setLanguage(language: Locale) — Locale is the full 10-value union from user/lib-esm/types.d.ts.
    {
      name: "setLanguage",
      args: [
        {
          k: "language",
          type: "enum",
          required: true,
          options: [
            "en_US",
            "de_DE",
            "es_ES",
            "fr_FR",
            "ja_JP",
            "it_IT",
            "ko_KR",
            "pt_BR",
            "zh_CN",
            "zh_TW",
          ],
        },
      ],
      mutating: true,
    },
    // setVisualMode(visualMode: VisualMode) — parameter is named "visualMode", not "mode".
    // VisualMode = "light" | "dark" | "auto"; "auto" was missing and unreachable from the UI.
    {
      name: "setVisualMode",
      args: [
        {
          k: "visualMode",
          type: "enum",
          required: true,
          options: ["light", "dark", "auto"],
        },
      ],
      mutating: true,
    },
  ],
};
